/**
 * Routes on which the app must NOT probe the session (GET /auth/session, then POST
 * /auth/refresh) when it mounts: they are reachable with no session by design, and none of
 * them reads auth state — the sign-in / ceremony pages only ever call `setSession` on
 * success. Probing there just produces expected anonymous 401s (logged by the browser as
 * console errors) on every visit.
 *
 * Everything else — every route wrapped in ProtectedRoute, and any route not listed here —
 * keeps the existing probe, so authenticated behaviour is unchanged. Moving from an exempt
 * route to a protected one (in-app navigation) still probes: see AuthProvider.
 *
 * Paths are router-relative (the `/landlord` basename is already stripped).
 */
const EXACT_PATHS: readonly string[] = [
  '/login',
  '/register',
];

const PREFIXES: readonly string[] = [
  '/auth/', // magic-link / email-code verification entry pages
  '/sign/', // token-authenticated public signing ceremony
];

export function isSessionProbeExemptPath(pathname: string): boolean {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return EXACT_PATHS.includes(normalized) || PREFIXES.some((p) => normalized.startsWith(p));
}
